@if (label) {
	<label class="form-label">
		{{ label }}
		@if (isRequired) {
			<span class="text-danger">*</span>
		}
	</label>
}

@if (type === "textarea") {
	<textarea
		class="form-control"
		[class.is-invalid]="hasError"
		[class.app-input__field--error]="error"
		[placeholder]="placeholder"
		[disabled]="disabled"
		[readonly]="readonly"
		[attr.maxlength]="maxlength"
		[value]="value"
		(input)="handleInput($event)"
		(blur)="handleBlur()"
		[rows]="rows"
		[cols]="cols"
	></textarea>
} @else {
	<input
		class="form-control"
		[class.is-invalid]="hasError"
		[class.app-input__field--error]="error"
		[type]="type === 'number' ? 'text' : type"
		inputmode="decimal"
		[placeholder]="placeholder"
		[readonly]="readonly"
		[disabled]="disabled"
		[attr.max]="max"
		[attr.min]="min"
		[attr.maxlength]="maxlength"
		[value]="value"
		(input)="handleInput($event)"
		(blur)="handleBlur()"
	/>
}

@if (hasError) {
	<div class="invalid-feedback d-block">
		{{ errorMessage }}
	</div>
} @else if (error) {
	<div class="text-danger small mt-1">{{ error }}</div>
} @else if (hint) {
	<div class="app-input__hint">{{ hint }}</div>
}
